module.exports = __webpack_public_path__ + "static/media/diving_640.0e2baccd.webp";